<template>
  <div class="container">
    <div class="main-content-text">
      <span class="update">Last updated: August 2025</span>
      <h1>Shipping & Delivery Policy – MyCelebrity Wish Feature</h1>
      <p>
        At <strong>MyCelebrity</strong>, all services under the Wish Feature are delivered digitally. No physical products are shipped.
      </p>
      <div class="gap-20"></div>
      <h3>1. Mode of Delivery</h3>
      <p>
        Fan requests are fulfilled through personalized video messages recorded by the celebrity.<br>
        Once completed, the video will be delivered to the fan via:
      </p>
      <ul>
        <li>The MyCelebrity platform/app (fan account).</li>
        <li>Email notification or download link (where applicable).</li>
      </ul>
      <div class="gap-20"></div>
      <h3>2. Delivery Timeline</h3>
      <p>
        The expected delivery time is mentioned on the celebrity’s profile page.<br>
        Typically, most videos are delivered within 7–14 working days, unless otherwise specified.<br>
        In cases of high demand, festivals, or special occasions, timelines may vary. Fans will be notified of any expected delays.
      </p>
      <div class="gap-20"></div>
      <h3>3. Non-Delivery</h3>
      <p>
        If a video is not delivered within the committed timeline due to reasons attributable to the celebrity, the order will be eligible for a full refund (as per our Cancellation & Refund Policy).
      </p>
      <div class="gap-20"></div>
      <h3>4. No Physical Shipping</h3>
      <p>
        Since this is a digital-only service, there are no shipping charges, courier services, or tracking numbers.<br>
        Fans will receive delivery confirmations via email/app notifications only.
      </p>
      <div class="gap-20"></div>
      <h3>5. Contact Us</h3>
      <p>
        For any concerns regarding delivery timelines or access to your video:
      </p>
      <ul>
  <li>📩 Email: <a href="mailto:support@mycelebrity.in">support@mycelebrity.in</a></li>
       
      </ul>
      <div class="gap-20"></div>
      <p><strong>✅ In short:</strong> All videos are digitally delivered, usually within 7–14 working days. No physical shipping is involved.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShippingDeliveryPolicy",
};
</script>

<style lang="scss" scoped>
.main-content-text {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 15px;
  }

  h1 {
    font-size: 30px;
  }

  h2 {
    font-size: 26px;
  }

  h3 {
    font-size: 22px;
    font-weight: 600;
  }

  h4 {
    font-size: 22px;
  }

  h5 {
    font-size: 18px;
  }

  h6 {
    font-size: 16px;
  }

  ul {
    margin-bottom: 15px;
    padding-left: 20px;
  }

  li {
    margin-bottom: 8px;
  }

  .update {
    display: block;
    font-size: 13px;
    color: #888;
    margin-bottom: 10px;
  }

  .gap-20 {
    height: 20px;
  }
}
</style>
